import axios from "axios";

const {
  REACT_APP_PRE_PAIEMENT
} = process.env;

export class PrePaiementService {

  getPrePaiementDto() {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };    
    return axios(REACT_APP_PRE_PAIEMENT,
      
    {
      headers: header,
      withCredentials: 'omit'
    }
    
    );
  }


  redirectToPaiement(paiementLink) {
    window.location.assign(paiementLink);
  }


}
